"use client";

import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { SigninLinkButton } from "@/components/ui/signin-link";

interface SignInPromptModalProps {
  children: React.ReactNode;
  dialogTitle: string;
  dialogDescription: string;
  /**
   * Full destination URL (path + search + hash) to redirect to after signin
   * @example "/listing/abc123?ref=email#place-bid"
   */
  destination?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function SignInPromptModal({
  children,
  dialogTitle,
  dialogDescription,
  destination,
  open,
  onOpenChange,
}: SignInPromptModalProps) {
  const [internalDialogOpen, setInternalDialogOpen] = useState(false);

  // Use external state if provided, otherwise use internal state
  const isDialogOpen = open !== undefined ? open : internalDialogOpen;
  const setIsDialogOpen = onOpenChange || setInternalDialogOpen;

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogDescription>{dialogDescription}</DialogDescription>
        </DialogHeader>
        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
          <SigninLinkButton destination={destination}>
            Sign in
          </SigninLinkButton>
        </div>
      </DialogContent>
    </Dialog>
  );
} 